import { injectIntl, defineMessages } from 'react-intl';
import { Field, reduxForm } from 'redux-form';
import React from 'react';
import { PropTypes as PT } from 'prop-types';
import _compact from 'lodash/compact';
import { MODERATOR_SEARCH_FORM } from 'constants/ContactModal';
import classes from 'components/ModalInput/ModalInput.module.scss';

const messages = defineMessages({
  moderatorPlaceholder: { id: 'components.contacts.meetingModal.moderatorPlaceholder', defaultMessage: 'Moderator' }
});

export const MODERATOR_LABEL = 'moderator';

class ModeratorSearchBar extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      placeholderText: props.intl.formatMessage(messages.moderatorPlaceholder)
    };
  }

  componentDidUpdate() {
    if (this.props.blurred) {
      this.blurAll();
    }
  }

  blurAll = () => {
    document.getElementById(MODERATOR_LABEL).blur();
    this.props.blurInput();
  };

  focus = () => {
    this.props.handleSetIsFocused(true);
  };

  handleTab = (evt) => {
    if (evt.which === 9) {
      this.props.handleSetIsFocused(false);
      return;
    }
    if (evt.which === 27) {
      this.props.handleSetIsFocused(false);
      this.blurAll();
      evt.stopPropagation();
      return;
    }

    this.props.handleSetIsFocused(true);
  };

  callInput = (inputProps) => {
    const { meta, input, required } = inputProps;
    const { boxType } = this.props;

    return (
      <div>
        <input
          {...input}
          autoComplete="new-password"
          className={_compact([!meta.active && classes.blurred, classes.filled]).join(' ')}
          id={MODERATOR_LABEL}
          name={this.props.passedName}
          onFocus={this.focus}
          onKeyDown={this.handleTab}
          type="text"
          data-testid="moderator-search-input"
          maxLength={64}
        />
        {!boxType && (
          <label htmlFor={MODERATOR_LABEL} className={required ? classes.requiredLabel : ''}>
            {this.state.placeholderText}
          </label>
        )}
        {this.props.children}
      </div>
    );
  };

  render() {
    const { contact, required } = this.props;
    return <Field name={'name'} component={this.callInput} type="text" contact={contact} required={required} />;
  }
}

ModeratorSearchBar.propTypes = {
  blurInput: PT.func,
  blurred: PT.bool,
  boxType: PT.bool,
  children: PT.element,
  contact: PT.object,
  handleSetIsFocused: PT.func,
  intl: PT.object,
  passedName: PT.string,
  required: PT.bool
};

export default reduxForm({
  form: MODERATOR_SEARCH_FORM,
  enableReinitialize: true,
  fields: [MODERATOR_LABEL],
  getFormState: (state) => state.app.form
})(injectIntl(ModeratorSearchBar));
